import { Component, Input } from "@angular/core";
import { Community } from "../../../../models";

@Component({
  selector: "invite-to-community-button",
  templateUrl: "./invite-to-community-button.component.html",
  styleUrls: [
    "./invite-to-community-button.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class InviteToCommunityButtonComponent {
  @Input() community: Community;
  constructor() {}
}
